<div class="layout-wrapper">
  <div class="grid m-0">
    <div class="xl:col-4 lg:col-4 md:col-1"></div>
    <div class="col-12 xl:col-4 lg:col-4 md:col-10 sm:col-12 main-content-body">
      <router-outlet></router-outlet>
    </div>
    <div class="xl:col-4 lg:col-4 md:col-1"></div>
  </div>
</div>
